<template>
  <div style="width: 100%" class="chat-input-body">
    <el-row v-if="parentMessage" class="chat-input-answer-message">
      <el-col :span="20" class="chat-input-answer-message-text">
        <span>
          <router-link :to="{name: 'Profile', params: {id: parentMessage.senderId}}"
          class="chat-input-answer-message-sender-name">
            {{ `${parentMessage.senderName}` }}
          </router-link>
        </span>
        <div>
          {{parentMessage.text}}
        </div>
      </el-col>
      <el-col class="chat-input-answer-message-button" :span="2">
        <el-button text @click="$emit('removeParentMessage')"><i class="fas fa-times"></i> </el-button>
      </el-col>
    </el-row>
    <div v-if="photos"  class="chat-input-photos">
      <el-row>
        <el-col :span="3" v-for="photo in photos" :key="photo.id" style="width: 100%">
          <div style="position: relative; width: 85px;">
            <el-image
                v-if="photo.type === 'ALBUM'"
                style="width: 85px; height: 85px"
                :src="`${$imageURL}api/Photo?id=${photo.id}`"
                fit="cover"></el-image>
            <el-image
                v-else-if="photo.type === 'UPLOADED'"
                style="width: 85px; height: 85px"
                :src="photo.base64"
                fit="cover"></el-image>
            <el-button text style="position: absolute;
                              top: 2px;
                              right: 5px;
                              color: white;
                              min-height: 20px;
                              padding-top: 0;
                              padding-bottom: 0;"
                       @click="deletePhoto(photo.id)">
              <i class="fas fa-times"></i></el-button>
          </div>
        </el-col>
      </el-row>
    </div>
    <div v-if="attach.length !== 0" style="border-bottom: 1px solid #e4e4e6;">
      <div v-for="f in attach" :key="f.id" style="font-size: 12px; text-align: end; padding-right: 16px;">
        <attachment-icon :type="f.type"></attachment-icon>
        <span style="margin: 0 6px;">{{f.name}}</span>
        <el-button style="min-height: 20px; padding: 0;" text @click="deleteAttachment(f.id)"><i class="fas fa-times"></i></el-button>
      </div>
    </div>
    <el-row class="chat-input-message">
      <el-col :span="2" v-if="!hideAvatar">
        <user-avatar :user-id="currentUserId" :factor="1.25"></user-avatar>
      </el-col>
      <el-col :span="hideAvatar?22:20">
        <div class="profileNewPostBlock">
          <div class="textarea_wrap">
            <div
              type="textarea"
              @focus="focused = true"
              :autosize="{ minRows: 1, maxRows: 6 }"
              resize="none"
              class="text_input textarea profileNewPostInput"
              :placeholder="$t('chats.writeMessage')"
              ref="textarea"
              @input="chatInput"
              :contenteditable="true"
              @keydown="keyDownEnter"
              @paste="copyText"
            >
            </div>
            <div class="text_input textarea shadow" ref="shadow">
              {{ messageText }}
            </div>
          </div>
          <el-popover
              placement="top"
              trigger="click"
              :popper-class="!isCallDialog ? 'emoji-container-chat' : 'emoji-container-call-dialog'"
          >
            <Picker :data="emojiIndex" set="twitter" @select="showEmoji" :showPreview="false"/>
            <template #reference>
              <button class="smallButton"><IconSmill :height="22" :width="22"/></button>
            </template>
          </el-popover>
          <div class="chat-input-dropdown" v-if="!hideAttach">
            <button class="smallButton" style="right: 0.8em; !important;">
              <IconPaperclip :height="22" :width="22"/>
            </button>
            <div class="chat-input-dropdown-content">
              <a @click="dialogAddPhoto = true">{{$t('chats.photos')}}</a>
              <a @click="dialogAddAttach = true">{{ $t('chats.files') }}</a>
            </div>
          </div>
        </div>
      </el-col>
      <el-col :span="2"  style="text-align: center; cursor:pointer;" @click="submit">
        <span style="display: inline-block; vertical-align: middle; height: 100%; padding-top: 10%;">
          <IconSendMessage :width="29" :height="25" />
        </span>
      </el-col>
    </el-row>
      <add-attachment-to-post :dialog="dialogAddAttach"
                              :attachDialogOpenAndPostDontCreated="attachDialogOpenAndPostDontCreated"
                              @closeDialog="closeDialogAddAttachment"
                              @attachAttachment="attachAttachment"
      ></add-attachment-to-post>
      <add-message-photo :dialog="dialogAddPhoto"
                         :unselectedPhoto="unselectedPhoto"
                         :clean="cleanAddPhotosFormData"
                         @closeDialog="closeDialogAddPhoto"
                         @attachPhoto="attachPhoto"
                         @delete-uploaded="deletePhoto"
      ></add-message-photo>
  </div>
</template>

<script>
import {MESSAGE_PHOTO_TYPES} from "@/constants"
import AddMessagePhoto from "../chats/AddMessagePhoto";
import addAttachmentToPost from "../Attachment/addAttachmentToPost";
import AttachmentIcon from '../Attachment/attachmentIcon'
import data from "emoji-mart-vue-fast/data/all.json";
import {Picker, EmojiIndex} from "emoji-mart-vue-fast/src";
import UserAvatar from "../avatars/UserAvatar";
import {mapGetters} from "vuex";
import CommonMixins from '@/mixins/common-mixins';

let emojiIndex = new EmojiIndex(data);
export default {
  mixins: [CommonMixins],
  emits: ["submit", "removeParentMessage"],
  props: {
    currentChatId: String,
    hideAttach: { type: Boolean, default: false },
    hideAvatar: { type: Boolean, default: false },
    hideMic: Boolean,
    parentMessage: { type: Object, default: null },
    maxHeight: {type: String, default: '250px'},
    isCallDialog: {type: Boolean, default: false}
  },
  components: {
    UserAvatar,
    Picker,
    AddMessagePhoto,
    addAttachmentToPost,
    AttachmentIcon
  },
  data() {
    return {
      messageText: "",
      focused: false,
      emojiIndex: emojiIndex,
      attach: [],
      unselectedPhoto : [],
      photos: [],
      attachDialogOpenAndPostDontCreated: false,
      dialogAddPhoto: false,
      dialogAddAttach: false,
      counterRow: 0,
      cleanAddPhotosFormData: [true]
    }
  },
  computed: {
    ...mapGetters("context", ["currentUserId"]),
    albumPhotos(){
      return this.photos.filter(photo => photo.type === MESSAGE_PHOTO_TYPES.ALBUM)
    },
    uploadedPhotos(){
      return this.photos.filter(photo => photo.type === MESSAGE_PHOTO_TYPES.UPLOADED)
    }
  },
  watch: {
    messageText(){
      this.updateHeight()
    }
  },
  methods: {
    copyText(event){
    },
    keyDownEnter(event) {
      let charCode = event.keyCode || event.which;
      if (charCode === 13) {
        event.preventDefault();
        if (event.ctrlKey || event.shiftKey) {
          let brNode = document.createElement("br");
          let selection = window.getSelection();
          let offset = selection.focusOffset;
          selection.modify("move", "forward", "character");
          let endOfWord = false;
          if (offset === selection.focusOffset) endOfWord = true;
          else selection.modify("move", "backward", "character");
          let range = selection.getRangeAt(0);
          range.deleteContents();
          range.insertNode(brNode);
          if (endOfWord) {range.insertNode(brNode);range.insertNode(document.createElement("br"));}
          range.collapse();
          this.chatInput();
        } else {
          this.submit();
          this.cleanAddPhotosFormData = [true]
        }
      }
    },
    chatInput() {
      //this.$refs.textarea.innerHTML = this.deleteStyles(this.$refs.textarea.innerHTML)
      const trimmedMessage = this.trimInnerText(this.$refs.textarea.innerHTML);
      if(!trimmedMessage){
        this.messageText = null;
        return;
      }
      this.messageText = this.replaceEmojiWithAltAttribute(
          this.deleteStyles(trimmedMessage)
      );
    },
    deleteStyles(text){
      if(text.indexOf('twemoji') !== -1)
        return text;
      const textSlices = text.split('"')
      const deletingIndex = [];
      for(let index in textSlices){
        if(textSlices[index].indexOf("style") !== -1){
          deletingIndex.push(Number(index)+1);
        }
      }
      for(let index of deletingIndex){
        textSlices.splice(index,1,'');
      }
      return textSlices.join('"');
    },
    trimInnerText(value){
      const replaced  = value.replace(/&nbsp;/g,' ');
      return replaced.trim();
    },
    updateHeight() {
      if(!this.messageText || this.messageText === "")
        this.$refs.textarea.style.height = '100%';
      else
      {
        this.$refs.textarea.style.height = (this.$refs.shadow.clientHeight + 10) + 'px'
      }
    },
    async submit() {
      if (this.messageText && !!this.messageText.trim() || this.attach.length !== 0 || this.photos.length !== 0) {

        let photoIds = this.albumPhotos.map(photo=>photo.id);
        let uploadedPhotoIds = []

        for(let photo of this.uploadedPhotos)
        {
          let formData = new FormData()
          formData.append('file', photo.file)

          let photoId = (await this.$http({
            method: 'POST',
            url: `conversation/message/${this.currentChatId}/photo`,
            data: formData,
            headers: {'Content-Type': 'multipart/form-data'}
          })).data

          uploadedPhotoIds.push(photoId)
        }

        this.$emit("submit", this.messageText, this.attach, photoIds, uploadedPhotoIds, this.parentMessage?.id, this.parentMessage !== null, null);
        this.messageText = "";
        this.attach = [];
        this.photos = [];
        this.cleanAddPhotosFormData = [true]
        this.attachDialogOpenAndPostDontCreated = false;
        this.$refs.textarea.innerHTML = "";
        this.$emit('removeParentMessage')
      }
    },
    showEmoji(emoji) {
      this.$refs.textarea.append(emoji.native);
      this.emojiParse(this.$refs.textarea);
      this.chatInput();

    },
    deleteAttachment(id){
      this.attach = this.attach.filter(x => x.id !== id);
    },
    deletePhoto(id){
      let photo = this.photos.find(photo=>photo.id === id)
      this.photos = this.photos.filter(photo => photo.id !== id)
      this.unselectedPhoto = [photo] //костыль, чтобы отрабатывал watch
    },
    attachPhoto(attachPhotos) {
      this.photos = attachPhotos;
      this.closeDialogAddPhoto();
    },
    closeDialogAddPhoto() {
      this.dialogAddPhoto = false
    },
    closeDialogAddAttachment() {
      this.dialogAddAttach = false
      this.attachDialogOpenAndPostDontCreated = true
    },
    attachAttachment(attachAttachments) {
      this.attach = attachAttachments
      this.closeDialogAddAttachment()
    }
  }
}
</script>

<style>
.emoji-container-call-dialog{
  inset: auto !important;
  left: -15px !important;
  bottom: 0 !important;
  width: 355px !important;
}
.emoji-container-call-dialog .el-popper__arrow{
  visibility: hidden;
}
.emoji-container-chat{
  width: 355px !important;
}
.emoji-container-chat .el-popper__arrow{
  visibility: hidden;
}

.smallButton {
  position: absolute;
  right: .4em;
  top: .1em;
  height: 40px;
  border: 0;
  background: transparent;
  text-transform: uppercase;
  font-size: 24px;
  color: #008FD1;
}
/* answer message */
.chat-input-body .chat-input-answer-message{
  border-bottom: 1px solid var(--chats-input-border);
  background-color: var(--chats-input-background);
  color: var(--chats-text);
}
.chat-input-photos{
  padding: 5px;
  border-bottom: 1px solid var(--chat-line);
}
.chat-input-body .chat-input-answer-message-sender-name{
  font-style: normal;
  font-weight: normal;
  font-size: 15px;
  line-height: 18px;
  color: var(--labelText);
  text-decoration: none;
  margin-bottom: 5px;
}
.chat-input-body .chat-input-answer-message-text{
  margin: 5px 0 5px 50px;
  padding-left: 16px;
  border-left: 2px solid var(--chats-header-button-background);
}
.chat-input-body .chat-input-answer-message-button{
  color: var(--chats-header-button-background);
}
/* */
.chat-input-dropdown{
  position: absolute;
  display: inline-block;
  top: 0;
  right: 1.8em;
}
.chat-input-dropdown-content{
  display: none;
  position: absolute;
  background-color: var(--chat-dropdown-background);
  z-index: 1;
  padding: 10px 0;
  font-size: 15px;
  font-weight: 400;
  border-radius: 5px;
  color: var(--chats-text);
  text-align: start;
  width: 245px;
  right: 15px;
  top: -90px;
  box-shadow: 0 4px 24px 0 var(--dropdown-shadow);
}
.chat-input-dropdown-content a {
  color: var(--chats-text);
  padding: 9px 20px;
  text-decoration: none;
  display: block;
}
.chat-input-dropdown-content a:hover {background-color: var(--chat-dropdown-background-hover)}
.chat-input-dropdown:hover .chat-input-dropdown-content{
  display: block;
}
/* input */
.profileNewPostBlock {
  position: relative;
}
.textarea_wrap {
  position: relative;
}
.textarea {
  font-family: Lato, sans-serif;
  line-height: 1.5;
  min-height: 40px;
  padding-top: 10px;
  overflow-y: scroll;
  resize: none;
  width: 100%;
  border: none;
  outline: none;
  background-color: var(--chats-input-background);
}
.textarea::placeholder{
  font-family: Lato, sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 15px;
  line-height: 18px;
  color: var(--labelText);
}
.textarea::-webkit-scrollbar-track {
  border: 1px solid #fff;
  padding: 2px 0;
  background-color: #fff;
}
.textarea::-webkit-scrollbar {
  width: 0;
}
.textarea::-webkit-scrollbar-thumb {
  border-radius: 10px;
  box-shadow: inset 0 0 6px rgba(0,0,0,.3);
  background-color: #008FD1;
  border: 1px solid #008FD1;
}
.shadow {
  position: absolute;
  left: -9999px;
  pointer-events: none;
  white-space: pre-wrap;
  word-wrap: break-word;
  resize: none;
}
.profileNewPostInput{
  top: .4em;
  padding-right: 6em;
  background: var(--chat-input-background);
  border: 1px solid var(--chat-input-background-border);
  box-sizing: border-box;
  border-radius: 8px;
  width: 100%;
  height: 40px;
  padding-left: 20px;
  color: var(--chats-input-text);
  max-height: 120px;
}
</style>

<style scoped>
/* message */
.chat-input-body .chat-input-message{
  display: flex;
  width: 100%;
  padding: 20px 20px 20px 15px;
}
</style>
